"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserLogContextManager = void 0;
const global_1 = require("../api/global");
const context_1 = require("../base/context");
// For now we don't provide a context manager for the browser
class BrowserLogContextManager extends context_1.BaseLogContextManager {
    getExecutionContext() {
        return {};
    }
    with(_context, fn) {
        return fn();
    }
}
exports.BrowserLogContextManager = BrowserLogContextManager;
(0, global_1.registerGlobal)('contextManager', new BrowserLogContextManager());
//# sourceMappingURL=context.js.map